module.exports = __webpack_public_path__ + "static/media/drdiary_03.6037f3c4.png";